import { useEffect, useState } from 'react';

import { useAuth } from 'context/AuthContext';
import { updateUserProfile } from 'services/profile.service';
import { getTutorialById } from 'services/tutorial.service';

/** Passo do `tutorial_inicial` (`tutorial__c` ou, para a Rede, `tutorial_rede__c`). */
export interface TutorialStep {
  /** HTML do passo. */
  text?: string;
  video?: string;
  /** Duração do vídeo, como "2:05". */
  minutes?: string;
}

/**
 * Carrega o tutorial inicial e diz quando fechá-lo. Abre para quem ainda não o concluiu
 * (`extra.tutorial`) ou quando `open` pede. Fechar marca `extra.tutorial` no perfil.
 *
 * Compartilhado pelo modal da casca (`TutorialModal`) e pelo `UserTutorial` da Home `/v2`,
 * que segue com a pele antiga.
 */
export function useInitialTutorial(open?: boolean) {
  const { user, refreshUser } = useAuth();
  const [steps, setSteps] = useState<TutorialStep[]>();

  useEffect(() => {
    async function loadTutorial() {
      if (user && (!user.extra.tutorial || open)) {
        const data = await getTutorialById('tutorial_inicial');

        if (data?.steps?.length > 0) {
          setSteps(data.steps);
        }

        localStorage.setItem('tutorial', 'true');
      }
    }

    loadTutorial();
  }, [user, open]);

  async function closeTutorial(onClose?: () => void) {
    setSteps(undefined);
    if (onClose) onClose();

    await updateUserProfile({
      _id: user?._id,
      extra: {
        ...user?.extra,
        tutorial: true,
      },
    });
    refreshUser();
  }

  return { steps, closeTutorial };
}
